<!-- TEMPLATE CONTRACT: Ui Filter Bar Component owns the visible Angular template structure for src/app/shared/ui/ui-filter-bar/ui-filter-bar.component.html. -->
<div class="ui-filter-bar" role="tablist" [attr.aria-label]="'uiLabels.filters' | uiLabelTranslate">
  <!-- Toolbar/filter section for narrowing visible data. -->
  @for (filter of filters(); track filter.value) {
    <button
      type="button"
      class="ui-filter-bar__item"
      [class.ui-filter-bar__item--active]="filter.value === selected()"
      [class.ui-filter-bar__item--disabled]="filter.disabled ?? false"
      [attr.aria-label]="'shared.filterBar.filterOption' | translate: { label: (normalizeLabel(filter.label) | uiLabelTranslate) }"
      [attr.aria-selected]="filter.value === selected()"
      [attr.aria-disabled]="filter.disabled ?? false"
      [disabled]="filter.disabled ?? false"
      (click)="select(filter.value, filter.disabled)"
    >
      {{ normalizeLabel(filter.label) | uiLabelTranslate }}
    </button>
  }
</div>
